module.exports = __webpack_public_path__ + "static/media/gltf-icon.bb1738fd.svg";